// extracted by css-extract-rspack-plugin
export default {"sortDropdownButton":"SortingDropdown-module__sortDropdownButton__DgU1p5K"};